import React from 'react'
import PropTypes from 'prop-types'

export const ConfirmButton = ({ onClick }) =>  <button onClick={onClick} className='confirm-btn'>POTVRDI</button>

ConfirmButton.propTypes = { onClick: PropTypes.func.isRequired }
